@let message = successMessageService.message();
@if (message) {
  <div class="toast toast-bottom toast-center" (click)="reset()">
    <div class="alert alert-success">
      {{ message | translate }}
    </div>
  </div>
}
